<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import { CategoryGroup } from "@core/schema/CategoryGroup.js";
	import ProductionAndServicesPage from "../components/ProductionAndServicesPage.svelte";
	import ProductsPage from "../components/ProductsPage.svelte";
	import type { CategoryGroupsProps } from "./CategoryGroupsProps.js";

	const { categories, categoryGroup }: CategoryGroupsProps = $props();

	const filteredCategories = $derived(categories.filter((category) => category.parentCategory === categoryGroup));
</script>

<Layout>
	{#if categoryGroup === CategoryGroup.Products}
		<!-- TODO chybí H1 a desc pro stránku - musí domyslet grafik/copy -->
		<ProductsPage categories={filteredCategories} />
	{:else if categoryGroup === CategoryGroup.ProductionAndServices}
		<ProductionAndServicesPage categories={filteredCategories} />
	{/if}
</Layout>
